module.exports = __webpack_public_path__ + "img/head-ico.8d5e3452.svg";